import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { FormControl, FormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { emailValidationPattern } from '../../../../constants/pattern.constants';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { UserService } from '../../../../services/user.service';
import { AuthButtonComponent } from '../../../molecules/auth-button/auth-button.component';
import { InputComponent } from '../../../atoms/input/input.component';
import { AuthTemplateComponent } from '../../../organisms/auth-template/auth-template.component';
import { descriptions, titles } from './reset.constants';
import { RoutesEnum } from '../../../../enums/routes.enum';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  imports: [AuthTemplateComponent, FormsModule, InputComponent, AuthButtonComponent],
})
export class ResetComponent {
  readonly RequestStateEnum = RequestStateEnum;

  public formControl = new FormControl<string | null>(null, [
    Validators.required,
    Validators.email,
    Validators.pattern(emailValidationPattern),
  ]);
  public requestState: WritableSignal<RequestStateEnum | null> = signal(null);
  public description: Signal<string> = computed(() => this.updateDescription());
  public title: Signal<string> = computed(() => this.updateTitle());
  private userService: UserService = inject(UserService);
  private router: Router = inject(Router);

  public resetPassword(): void {
    this.requestState.set(RequestStateEnum.PENDING);

    this.userService
      .resetPassword(this.formControl.value!)
      .pipe(
        catchError(() => {
          this.requestState.set(RequestStateEnum.ERROR);
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.requestState.set(RequestStateEnum.SUCCESS);
      });
  }

  public goToLogin(): void {
    this.router.navigateByUrl(RoutesEnum.COMMON_LOGIN);
  }

  public get showForm(): boolean {
    return this.requestState() === RequestStateEnum.PENDING || this.requestState() === null;
  }

  private updateDescription(): string {
    switch (this.requestState()) {
      case RequestStateEnum.PENDING:
        return descriptions.pending!;

      case RequestStateEnum.ERROR:
        return descriptions.error!;

      case RequestStateEnum.SUCCESS:
        return descriptions.success!;

      default:
        return descriptions.default!;
    }
  }

  private updateTitle(): string {
    switch (this.requestState()) {
      case RequestStateEnum.SUCCESS:
        return titles.success;

      case RequestStateEnum.ERROR:
        return titles.error;

      default:
        return titles.default;
    }
  }
}
